import { TableCellText } from '../../../../../../Table'

function ApplicantProfileEmailsMessage({ item }) {
  return (
    <>
      <TableCellText
        showTooltip={false}
        unread={!item.is_read}
        value={item.subject}
      />
      {item.snippet ? (
        <TableCellText isSecondary showTooltip={false} value={item.snippet} />
      ) : null}
    </>
  )
}

export default ApplicantProfileEmailsMessage
